module.exports = __webpack_public_path__ + "img/munis360tutorial-min.2694d85e.gif";